import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

export const getFactContent = (payload) => {
  return MessageBroker.send(RequestUrls.FactSubstanceDetails, payload);
};

export const getDruglikenessContent = (payload) => {
  return MessageBroker.send(RequestUrls.DruglikenessSubstanceContent, payload);
};

export const getDruglikenessByXrn = (payload) => {
  return MessageBroker.send(RequestUrls.DruglikenessSubstanceDetails, payload);
};

export const getBioCategories = (payload) => {
  return MessageBroker.send(RequestUrls.BioSubstanceCategories, payload);
};

export const getBioPair = (payload) => {
  return MessageBroker.send(RequestUrls.BioSubstancePair, payload);
};

export const getBioContent = (payload) => {
  return MessageBroker.send(RequestUrls.BioSubstanceContent, payload);
};
